<template>
  <modal class="callus-modal" @close-modal="closeCallUsModal" :showClose="true">
    <template v-slot:content>
        <img class="callus-modal__theme-logo" :src="themeLogo" />
        <div class="callus-modal__header">
          <img :src="phoneCallIcon" class="callus-modal__must-call-icon" />
          <h3 class="callus-modal__sub-header">Please Call Us</h3>
        </div>

        <p class="callus-modal__info mb-1">This dumpster requires a quick phone call so our dispatchers can confirm availability before completing your order.</p>

        <p class="callus-modal__info mb-1">
          We apologize for the extra step, but it only takes a minute! Give us a call, or
          <a class="callus-modal__from-link" :href="onlineForm" target="_blank">fill out this quick online form</a>
          and we’ll follow up with you shortly.
        </p>
        <a :href="`tel:${phoneNumber}`" class="btn btn--secondary btn--orange mt-1">{{phoneNumber}}</a>
    </template>
  </modal>
</template>

<script>
import modal from '@/components/Modal.vue'
import config from '@/config'
const { cdn, phoneNumber, links: { onlineForm } } = config
export default {
  components: {
    modal
  },
  data () {
    return {
      themeLogo: `${cdn}theme-logo.png`,
      phoneCallIcon: `${cdn}icons-phone-call.svg`,
      phoneNumber,
      onlineForm
    }
  },
  methods: {
    closeCallUsModal () {
      this.$emit('close-modal')
    }
  }
}
</script>
